export const categories = [
  {
    slug: 'xing-jian-kang-zhi-shi',
    name: '性健康知识',
    description: '科学、专业的性健康科普，涵盖生理卫生、常见问题与预防保健',
    icon: 'ri-heart-pulse-line',
  },
  {
    slug: 'qin-mi-guan-xi',
    name: '亲密关系',
    description: '探索两性关系中的情感连接、相处之道与关系维护',
    icon: 'ri-user-heart-line',
  },
  {
    slug: 'xing-xin-li-jian-kang',
    name: '性心理健康',
    description: '关注性心理发展、情感需求与心理健康调适',
    icon: 'ri-psychotherapy-line',
  },
  {
    slug: 'ban-lv-gou-tong',
    name: '伴侣沟通',
    description: '提升伴侣间的沟通技巧，建立健康的对话模式',
    icon: 'ri-chat-smile-2-line',
  },
  {
    slug: 'xing-fu-sheng-huo',
    name: '性福生活',
    description: '探索和谐、愉悦的性生活体验，提升亲密生活品质',
    icon: 'ri-sun-line',
  },
];

export const allArticles = [
  {
    slug: 'nv-xing-xing-jian-kang-chang-jian-wu-qu',
    title: '女性性健康的5个常见误区，90%的人都理解错了',
    excerpt: '从科学角度解读女性性健康中容易混淆的认知，帮助女性建立正确的自我认知与健康观念。',
    category: 'xing-jian-kang-zhi-shi',
    image: 'https://readdy.ai/api/search-image?query=Warm%20soft%20artistic%20abstract%20illustration%20of%20feminine%20wellness%20with%20gentle%20coral%20and%20cream%20tones%2C%20minimalist%20botanical%20elements%2C%20flowing%20organic%20shapes%2C%20soft%20lighting%2C%20healing%20and%20nurturing%20vibe&width=800&height=500&seq=article-women-health&orientation=landscape',
    author: '李医生',
    authorTitle: '妇产科主治医师',
    date: '2026-07-28',
    readTime: '8分钟',
    content: `<p>在性健康教育领域，存在着大量以讹传讹的说法。这些错误认知不仅影响女性的自我认知，更可能对身心健康造成潜在的负面影响。本文将从科学角度，逐一澄清最为普遍的5个误区。</p><h2>误区一：性欲低下是"不正常"的</h2><p>事实上，性欲的高低如同身高体重一样，存在着巨大的个体差异。每个人体内的激素水平、生活状态、心理状态都不尽相同，因此性欲的强弱也千差万别。医学上并不存在一个"标准"的性欲水平。只有当性欲变化对个人造成了持续的困扰或痛苦，并且排除了生理原因后，才可能需要关注。</p><h2>误区二：更年期意味着性生活的终结</h2><p>这是一个极其普遍的误解。虽然更年期确实会带来体内雌激素水平的下降，可能导致阴道干涩等不适，但这绝不意味着性生活的终结。通过科学的调理、适当的润滑产品使用以及与伴侣的良好沟通，更年期后的女性完全可以享受充实而愉悦的性生活。事实上，许多女性在更年期后反而感到更加自由和放松。</p><h2>误区三：妇科检查很可怕</h2><p>定期的妇科检查是女性健康的重要保障，却因为各种误解而被很多人回避。现代妇科检查已经非常注重患者的舒适体验，检查过程通常快捷、温和。与其因为恐惧而回避检查，不如主动了解检查流程，选择信赖的医疗机构。</p><h2>误区四：私密护理产品越用越健康</h2><p>市场上琳琅满目的女性私密护理产品，让很多人误以为用得越多越健康。实际上，健康的阴道拥有自我清洁的能力，过度使用洗液反而会破坏正常的菌群平衡，增加感染风险。日常清洁使用温水即可。</p><h2>误区五：性教育会让年轻人更早发生性行为</h2><p>大量的研究数据表明，全面、科学的性教育不但不会促使年轻人更早发生性行为，反而能够推迟初次性行为的年龄，并降低意外怀孕和性传播疾病的风险。知识就是力量，这句老话在性教育领域同样适用。</p>`,
    tags: ['女性健康', '性教育', '健康科普', '妇科'],
    faq: [
      { question: '女性性欲低下需要治疗吗？', answer: '只有当性欲低下对个人造成持续困扰时，才建议寻求专业帮助。医生会综合评估生理和心理因素，制定个性化的方案。' },
      { question: '更年期后如何维持健康的性生活？', answer: '可以通过使用水基润滑剂、保持规律的性生活、加强盆底肌锻炼、与伴侣坦诚沟通等多种方式。必要时可咨询妇科医生。' },
    ],
  },
  {
    slug: 'xing-sheng-huo-gou-tong-ji-qiao',
    title: '如何与伴侣坦诚沟通性需求？这6个技巧让对话不再尴尬',
    excerpt: '学会在亲密关系中表达真实的性需求与感受，是每对伴侣走向更深层次亲密的关键一步。',
    category: 'ban-lv-gou-tong',
    image: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20two%20people%20having%20intimate%20conversation%2C%20soft%20amber%20and%20coral%20color%20palette%2C%20flowing%20gentle%20shapes%2C%20emotional%20connection%20theme%2C%20minimalist%20style%20with%20warm%20light&width=800&height=500&seq=article-communication&orientation=landscape',
    author: '王心理咨询师',
    authorTitle: '国家二级心理咨询师',
    date: '2026-07-25',
    readTime: '10分钟',
    content: `<p>在亲密关系中，"说不出口"是最常见的困境之一。很多人因为害怕被拒绝、担心伤害对方或者缺乏表达经验，选择将真实的感受和需求埋藏在心底。然而，回避沟通只会让隔阂越来越深。以下6个实用技巧，或许能帮你打开那扇对话的门。</p><h2>1. 选择合适的时机与环境</h2><p>避免在性行为进行中或刚结束时讨论敏感话题，那时双方的情绪状态都不适合理性对话。选择一个双方都放松、不受打扰的安静时刻，比如散步时、喝茶时，用温和的语气开启对话。</p><h2>2. 使用"我"开头的表达</h2><p>与其说"你从来都不理解我"，不如说"我有时候觉得自己的想法没有被充分理解"。用"我"开头的表达方式，能够减少对方的防御心理，让对话保持在建设性的轨道上。</p><h2>3. 先肯定，再表达需求</h2><p>在提出改进意见之前，先真诚地表达对现有关系的珍视和满意之处。例如："我很喜欢我们之间的亲密，同时我也想和你分享一些我最近在思考的事情。"</p><h2>4. 避免在情绪激动时做决定</h2><p>如果对话过程中情绪变得激动，约定一个"暂停"信号，各自冷静后再继续。冲动之下说出的话，往往会在关系中留下难以修复的伤痕。</p><h2>5. 学习倾听的艺术</h2><p>沟通不只是说，更是听。当伴侣表达自己的感受和需求时，放下评判，专注倾听，尝试站在对方的立场上去理解。有时候，一个被充分倾听的伴侣，比什么都重要。</p><h2>6. 必要时寻求专业帮助</h2><p>如果在某些话题上始终无法达成有效的沟通，不要讳疾忌医。专业的性治疗师或伴侣咨询师能够提供科学、中立、有效的指导。</p>`,
    tags: ['伴侣沟通', '亲密关系', '情感技巧', '性沟通'],
    faq: [
      { question: '伴侣不愿意讨论性话题怎么办？', answer: '可以先从轻松的、非直接的话题入手，比如一起阅读相关的科普文章，用第三方视角引发讨论。给对方时间和空间，不要强迫。' },
      { question: '沟通后情况没有改善怎么办？', answer: '改变需要时间。如果多次尝试后仍无改善，建议考虑寻求专业的伴侣咨询师的帮助，他们有更系统的方法来协助你们。' },
    ],
  },
  {
    slug: 'xing-xin-li-jian-kang-zi-zun',
    title: '性自尊与身体意象：如何建立健康的自我认知',
    excerpt: '身体意象与性自尊密切相关，学会接纳自己的身体是走向健康性心理的重要基础。',
    category: 'xing-xin-li-jian-kang',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20art%20depicting%20self%20acceptance%20and%20body%20positivity%2C%20soft%20sage%20green%20and%20coral%20toned%20flowing%20organic%20shapes%2C%20gentle%20lighting%2C%20healing%20and%20empowerment%20theme&width=800&height=500&seq=article-body-image&orientation=landscape',
    author: '张心理师',
    authorTitle: '性心理治疗师',
    date: '2026-07-20',
    readTime: '7分钟',
    content: `<p>当我们谈论性健康时，往往忽略了最重要的基础——身体意象与性自尊。一个人对自己身体的感受，直接决定了他在亲密关系中的开放程度、放松程度，以及能够获得的满足感。</p><h2>什么是身体意象</h2><p>身体意象是我们对自己身体外观、功能和感受的整体认知和态度。健康积极的身体意象意味着能够欣赏和接纳自己的身体，即使它并不完美。而消极的身体意象则可能导致焦虑、回避亲密接触、甚至抑郁。</p><h2>社会文化的影响</h2><p>无处不在的媒体形象、社交媒体上的"完美身材"，每天都在无形中向人们灌输着单一且不切实际的审美标准。我们需要意识到，这些标准是被商业利益驱动的，而非健康的参考系。</p><h2>建立健康性自尊的三步法</h2><p>第一步：觉察——注意到自己对自己身体的负面评价，记录下来；第二步：挑战——问自己，这个评价是基于事实还是被灌输的标准？第三步：重建——用更中立、更友好的语言重新描述自己的身体。这不是一蹴而就的过程，但每一次练习都是向前的一小步。</p><h2>伴侣的支持作用</h2><p>伴侣的真诚赞美和接纳，对于建立健康的身体意象有着巨大的正面影响。如果你是那个给予支持的一方，请记住：具体、真诚的赞美，远比笼统的夸奖更有力量。</p>`,
    tags: ['性心理', '身体意象', '自我认知', '自尊'],
    faq: [
      { question: '如何帮助伴侣建立更好的身体自信？', answer: '用具体的、真诚的赞美替代笼统的夸奖。例如，与其说"你很美"，不如说"我喜欢你笑起来眼睛的弧度"。同时，保持耐心，不施加压力。' },
    ],
  },
  {
    slug: 'zhong-nian-fu-qi-qin-mi-guan-xi',
    title: '中年夫妻如何重燃亲密关系的火花？',
    excerpt: '随着婚姻时间的推移，很多夫妻发现亲密感在悄然流失。本文提供实用的方法帮助中年夫妻重新连接。',
    category: 'qin-mi-guan-xi',
    image: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20illustration%20of%20mature%20couple%20connection%2C%20soft%20terracotta%20and%20cream%20tones%2C%20minimalist%20organic%20shapes%20suggesting%20closeness%20and%20warmth%2C%20gentle%20emotional%20atmosphere&width=800&height=500&seq=article-midlife-couple&orientation=landscape',
    author: '赵关系顾问',
    authorTitle: '婚姻家庭咨询师',
    date: '2026-07-15',
    readTime: '12分钟',
    content: `<p>婚姻走过十年、二十年，当初的激情似乎被柴米油盐磨得所剩无几。然而研究表明，中年恰恰是重新定义和深化亲密关系的最佳时机。关键在于，双方是否愿意迈出第一步。</p><h2>理解中年阶段的特殊挑战</h2><p>中年夫妻面临着多重压力：事业的瓶颈期、养育子女的负担、父母年迈的照顾责任、以及身体机能的变化。在这样的背景下，亲密关系被挤压到边缘位置几乎是必然的。认识到这一点本身，就是一种释然——这不是你们的关系出了问题，而是生活阶段带来的自然挑战。</p><h2>重新定义亲密</h2><p>中年之后的亲密，不应该是年轻时激情的简单复制。它更多体现在共同面对生活的默契、彼此无言的理解、以及深层次的精神共鸣。接受亲密形式的转变，反而能打开新的可能性。</p><h2>创造专属的"两人时间"</h2><p>在繁忙的日程中，刻意安排只属于两人的时间。不一定是浪漫的烛光晚餐，也可以是每周固定的散步、一起做一顿饭、或者仅仅是睡前十五分钟的聊天。关键是——这段时间里，手机放下，注意力只在对方身上。</p><h2>尝试新事物</h2><p>一起学习一项新技能、探索一个新地方、尝试一种新活动——新鲜感能够激活大脑中的奖赏系统，带来类似于恋爱初期的兴奋感。这不仅能为关系注入活力，还能创造新的共同记忆。</p>`,
    tags: ['中年夫妻', '亲密关系', '婚姻经营', '情感连接'],
    faq: [
      { question: '中年夫妻性生活频率下降是正常的吗？', answer: '是的，随着年龄增长和生活压力的增加，性生活频率下降是普遍现象。重要的是质量而非数量，关注彼此的情感连接和亲密感更为关键。' },
    ],
  },
  {
    slug: 'an-quan-xing-xing-wei-zhi-nan',
    title: '安全性行为完全指南：你需要知道的一切',
    excerpt: '从避孕到性传播疾病预防，全面覆盖安全性行为所需的核心知识。',
    category: 'xing-jian-kang-zhi-shi',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20illustration%20about%20health%20and%20safety%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20organic%20shield-like%20shapes%2C%20gentle%20protective%20vibe%2C%20clean%20medical%20aesthetic&width=800&height=500&seq=article-safe-sex&orientation=landscape',
    author: '陈医生',
    authorTitle: '性健康科医师',
    date: '2026-07-10',
    readTime: '9分钟',
    content: `<p>安全性行为不仅仅是一个口号，它关乎每一个人的身心健康。无论你处于人生的哪个阶段，掌握安全性行为的基本知识都是对自己和伴侣负责的表现。</p><h2>避孕方式全面对比</h2><p>目前主流的避孕方式包括：避孕套（男用/女用）、口服避孕药、宫内节育器、皮下埋植、避孕针等。每种方式各有优缺点，选择时需要综合考虑有效性、便利性、副作用和个人健康状况。建议在医生指导下选择最适合自己的方式。</p><h2>性传播疾病的预防</h2><p>正确使用避孕套是目前最有效的预防性传播疾病的方法之一。此外，定期进行性健康检查、了解伴侣的健康状况、接种相关疫苗（如HPV疫苗）都是重要的预防措施。</p><h2>知情同意的重要性</h2><p>安全性行为不仅限于生理层面，心理层面的安全同样重要。每一次性行为都应该是双方自愿、清醒、知情的。任何一方都有权在任何时刻说"不"，而另一方必须无条件尊重这个决定。</p>`,
    tags: ['安全性行为', '避孕', '性传播疾病', '健康科普'],
    faq: [
      { question: '避孕套的失败率高吗？', answer: '正确使用的情况下，男用避孕套的失败率约为2%。但实际使用中由于使用不当，失败率可能达到15%。学习和坚持正确使用方法是关键。' },
      { question: 'HPV疫苗有必要接种吗？', answer: 'HPV疫苗能有效预防多种高危型HPV感染及相关癌症，建议适龄人群在医生指导下接种。' },
    ],
  },
  {
    slug: 'xing-fu-sheng-huo-xin-li-xue',
    title: '性福生活的心理学密码：从心开始的愉悦体验',
    excerpt: '真正的性福不仅仅是生理反应，更是心理状态的体现。了解性心理学，开启更丰富的身心体验。',
    category: 'xing-fu-sheng-huo',
    image: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20illustration%20of%20joy%20and%20fulfillment%2C%20soft%20golden%20amber%20and%20coral%20tones%2C%20flowing%20organic%20shapes%20suggesting%20harmony%2C%20gentle%20luminous%20atmosphere&width=800&height=500&seq=article-happiness-psych&orientation=landscape',
    author: '林心理学家',
    authorTitle: '临床心理学家',
    date: '2026-07-05',
    readTime: '11分钟',
    content: `<p>谈到性福，人们往往首先想到的是生理层面的因素。然而，越来越多的研究表明，心理状态在性体验中扮演着至关重要的角色。毫不夸张地说，大脑才是人体最大的性器官。</p><h2>正念与性体验</h2><p>正念（Mindfulness）——即专注于当下的能力——是提升性体验的一个有效方法。当我们能够将注意力集中在当下的身体感受上，而不是被焦虑、评判或外界干扰所占据时，性体验的质量会显著提升。简单的正念练习，如关注呼吸、感受身体的每一个细微触感，都可以成为改善性体验的起点。</p><h2>情绪状态的影响</h2><p>压力、焦虑、抑郁等负面情绪会显著抑制性欲和性反应。这并不是个人意志力的问题，而是神经内分泌系统的自然反应。在高压力的生活节奏中，学会管理情绪、为自己创造放松的空间，本身就是对性福生活的投资。</p><h2>期望管理的艺术</h2><p>媒体和影视作品塑造的"完美性爱"形象，在无形中给很多人带来了不切实际的期望。真实的性体验往往是多样的、不完美的、充满变化的。放下对"完美"的执念，反而能体验到更多的愉悦。</p>`,
    tags: ['性心理学', '正念', '情绪管理', '性福'],
    faq: [
      { question: '正念练习如何具体应用于性生活？', answer: '可以从简单的呼吸觉察开始，在亲密接触时将注意力带回到呼吸和身体感受上。当注意力游走时，不带评判地轻轻带回来。这需要练习，但效果显著。' },
    ],
  },
  {
    slug: 'shi-ba-sui-hou-xing-jiao-yu',
    title: '18岁之后，成年人的性教育必修课',
    excerpt: '学校没有教、父母羞于谈，成年后每个人都应该补上的性教育重要课题。',
    category: 'xing-jian-kang-zhi-shi',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20illustration%20of%20learning%20and%20knowledge%2C%20soft%20coral%20and%20cream%20tones%2C%20book-like%20geometric%20shapes%2C%20gentle%20educational%20atmosphere&width=800&height=500&seq=article-adult-edu&orientation=landscape',
    author: '李医生',
    authorTitle: '妇产科主治医师',
    date: '2026-06-28',
    readTime: '6分钟',
    content: `<p>我们的教育体系在性教育方面存在明显的空白。很多人在成年后才发现，自己对身体、关系、以及性健康知之甚少。本文梳理了成年人最应该了解的几堂性教育必修课。</p><h2>认识自己的身体</h2><p>了解自己的生殖系统构造和功能，这是最基本的健康素养。不仅是生理结构，还包括正常的生理反应、周期变化，以及如何识别异常信号。对于女性来说，了解月经周期、排卵期的规律；对于男性来说，了解前列腺健康的基本知识——这些都是对自己负责的表现。</p><h2>知情同意：不可逾越的底线</h2><p>知情同意（Informed Consent）是任何性行为不可逾越的底线。同意必须是自愿的、清醒的、知情的、可撤回的。任何时刻，任何一方都有权撤回同意，而另一方必须立即停止。这不是可以讨价还价的事情。</p><h2>多元化的性与性别认知</h2><p>性和性别是多元的光谱，而非简单的二元对立。尊重和理解不同的性取向和性别认同，不仅是对他人的尊重，更是拓宽自己认知边界的机会。</p>`,
    tags: ['性教育', '成年人', '知情同意', '生理健康'],
    faq: [],
  },
  {
    slug: 'gou-tong-zhong-mian-lin-de-nan-ti',
    title: '当沟通陷入僵局：伴侣冲突的化解之道',
    excerpt: '每对伴侣都会遇到沟通的死角。本文教你如何识别冲突模式并找到突破口。',
    category: 'ban-lv-gou-tong',
    image: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20art%20of%20resolution%20and%20harmony%2C%20soft%20amber%20and%20sage%20tones%2C%20two%20flowing%20shapes%20gradually%20merging%2C%20peaceful%20resolution%20theme&width=800&height=500&seq=article-conflict&orientation=landscape',
    author: '王心理咨询师',
    authorTitle: '国家二级心理咨询师',
    date: '2026-06-20',
    readTime: '9分钟',
    content: `<p>所有伴侣都会经历冲突，这本身不是问题。真正的问题在于如何处理冲突。健康的冲突处理能够让关系更加紧密，而不健康的模式则会让两人渐行渐远。</p><h2>识别四种破坏性的沟通模式</h2><p>心理学家约翰·戈特曼的研究识别出四种最具破坏性的沟通模式：批评（攻击对方的人格而非行为）、蔑视（以居高临下的态度对待对方）、防御（拒绝承担责任）、冷战（完全切断沟通）。如果你在关系中发现了这四种模式的任何一种，是时候认真面对了。</p><h2>从"我对你错"到"我们一起解决"</h2><p>冲突中最常见的陷阱是把对方当成需要打败的对手。试着转换视角：你们是在同一个团队里，面对的是同一个问题。把"你为什么不理解我"换成"我们怎样才能更好地理解彼此"——这一个微小的语言转换，可能改变整个对话的走向。</p><h2>学会"修复尝试"</h2><p>修复尝试是指在冲突升级过程中，任何一方发出的缓和信号——一个微笑、一句幽默、一个触碰。善于捕捉和回应对方的修复尝试，是维持健康关系的核心能力之一。</p>`,
    tags: ['伴侣冲突', '沟通技巧', '关系修复', '情感'],
    faq: [
      { question: '冷战持续多久才需要警惕？', answer: '没有固定的时间标准。如果冷战变成了一种习惯性的应对模式，且每次冷战都在拉长关系的距离感，就需要认真面对了。' },
    ],
  },
  {
    slug: 'xing-yu-di-xia-yuan-yin',
    title: '性欲低下的背后：你可能忽略的7个原因',
    excerpt: '性欲波动是常见现象，但如果长期低下，可能需要关注背后潜在的原因。',
    category: 'xing-xin-li-jian-kang',
    image: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20self%20reflection%20and%20introspection%2C%20soft%20coral%20and%20sage%20green%20tones%2C%20minimalist%20flowing%20shapes%2C%20gentle%20contemplative%20mood&width=800&height=500&seq=article-low-libido&orientation=landscape',
    author: '张心理师',
    authorTitle: '性心理治疗师',
    date: '2026-06-15',
    readTime: '8分钟',
    content: `<p>性欲波动是完全正常的。但当性欲持续处于低迷状态，并且对个人或关系造成了困扰时，了解背后的原因就变得重要了。以下7个常见但容易被忽视的因素，值得关注。</p><h2>1. 慢性压力</h2><p>长期处于高压状态，体内的皮质醇水平升高，会直接抑制性激素的分泌。这解释了为什么很多人在工作最忙的时期性欲会明显下降。</p><h2>2. 睡眠不足</h2><p>睡眠质量与性欲密切相关。深度睡眠期间，身体会分泌重要的激素。长期的睡眠不足会打乱整个内分泌系统的平衡。</p><h2>3. 药物副作用</h2><p>许多常见药物——包括某些抗抑郁药、降压药、口服避孕药——都可能影响性欲。如果你怀疑药物是原因，请与医生讨论是否有替代方案，切勿自行停药。</p><h2>4. 关系中的未解问题</h2><p>积压的怨恨、未表达的不满、信任的裂痕——这些关系层面的问题会直接反映在性欲上。</p><h2>5. 身体意象问题</h2><p>对自己身体的不满会让人在亲密时刻感到自我意识过强，无法放松和享受。</p><h2>6. 激素水平变化</h2><p>随着年龄增长或其他生理因素，性激素水平的变化可能影响性欲。这需要通过医学检查来确认。</p><h2>7. 心理健康状况</h2><p>抑郁症、焦虑症等心理健康问题常常伴随着性欲的减退。治疗这些根本问题，性欲往往也会随之改善。</p>`,
    tags: ['性欲低下', '心理健康', '压力管理', '激素'],
    faq: [
      { question: '性欲低下应该去看哪个科室？', answer: '可以先咨询全科或家庭医生做初步评估。根据情况，可能转诊至妇科/泌尿科、内分泌科、心理科或性医学科。' },
    ],
  },
  {
    slug: 'bian-yun-fang-shi-quan-mian-bi-jiao',
    title: '避孕方式全面大比拼：找到最适合你的那一种',
    excerpt: '从短效到长效，从激素到非激素，全面对比各类避孕方式的优缺点。',
    category: 'xing-jian-kang-zhi-shi',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20medical%20illustration%2C%20soft%20coral%20and%20cream%20tones%2C%20clean%20geometric%20comparison%20shapes%2C%20gentle%20informative%20vibe&width=800&height=500&seq=article-contraception&orientation=landscape',
    author: '陈医生',
    authorTitle: '性健康科医师',
    date: '2026-06-10',
    readTime: '10分钟',
    content: `<p>选择避孕方式没有"最好"的答案，只有"最适合"的选择。每个人的身体状况、生活方式、生育计划都不相同，因此需要综合考虑多种因素。</p><h2>男用避孕套</h2><p>优点：即用即弃、无激素影响、同时预防性传播疾病。缺点：需要每次使用、可能影响敏感度、存在使用不当的风险。</p><h2>短效口服避孕药</h2><p>优点：高效（正确使用99%以上）、可调节月经周期、对某些妇科问题有治疗作用。缺点：需要每日服用、有激素副作用、不预防性传播疾病。</p><h2>宫内节育器</h2><p>优点：长效（3-10年）、一劳永逸、取出后生育能力迅速恢复。缺点：放置过程有不适感、可能增加经量或经痛（铜环）、不预防性传播疾病。</p><h2>皮下埋植</h2><p>优点：长效（3年）、高效、不影响日常生活。缺点：可能导致不规则出血、需要小手术放置和取出。</p><p>无论选择哪种方式，建议在医生的指导下做出决定，并定期复查。</p>`,
    tags: ['避孕', '健康科普', '生育规划', '安全'],
    faq: [
      { question: '紧急避孕药可以经常使用吗？', answer: '不可以。紧急避孕药是高剂量激素，仅适用于紧急情况，不能作为常规避孕方式。频繁使用可能导致月经紊乱和内分泌失调。' },
    ],
  },
];

export const faqs = [
  {
    question: '性欲社的内容是否科学可靠？',
    answer: '性欲社的所有内容均由具有专业资质的医生、心理咨询师和性教育专家撰写或审核，参考文献均来自权威医学期刊和学术机构，确保信息的科学性和准确性。',
  },
  {
    question: '如何判断自己是否需要寻求专业帮助？',
    answer: '如果你在性健康或亲密关系方面持续感到困扰，且这种困扰已经影响到日常生活质量或伴侣关系，建议寻求专业帮助。专业的帮助并不意味着你有"病"，而是对自己负责的表现。',
  },
  {
    question: '性欲社的隐私保护做得如何？',
    answer: '我们高度重视用户隐私。浏览性欲社的内容不需要提供任何个人信息，我们也不会追踪用户的浏览行为。如果你通过表单联系我们，你的信息将被严格保密。',
  },
  {
    question: '可以在性欲社上提问吗？',
    answer: '目前你可以通过"联系我们"页面提交你的问题，我们的专家团队会定期选取有代表性的问题进行回答。未来我们将开通在线问答社区功能。',
  },
  {
    question: '性欲社的内容适合什么年龄段阅读？',
    answer: '性欲社面向18岁以上的成年人。我们致力于为成年人提供专业、负责任的性健康与亲密关系知识。如果你未满18岁，请在监护人指导下浏览。',
  },
  {
    question: '如何与性欲社合作或投稿？',
    answer: '我们欢迎具有相关专业背景的作者加入。如果你是一位医生、心理咨询师、性教育工作者或相关领域的研究者，欢迎通过"联系我们"页面向我们提交合作意向。',
  },
];

export const testimonials = [
  {
    name: '小雯',
    role: '读者',
    content: '性欲社的内容让我意识到，很多我一直以为"不正常"的感受其实都是正常的。这里的文章既有温度又有深度，让我对亲密关系有了全新的理解。',
  },
  {
    name: '浩然',
    role: '读者',
    content: '作为一个男性，我从小接受的教育让我羞于谈论性和情感。性欲社让我明白，关注性健康和情感需求不是软弱，而是勇敢和负责任。',
  },
  {
    name: '佳琳',
    role: '读者',
    content: '我和先生在一起十年了，最近感觉亲密感在流失。性欲社关于中年夫妻的文章给了我们很大启发，我们一起阅读、一起讨论，关系有了明显改善。',
  },
  {
    name: '明哲',
    role: '读者',
    content: '专业性非常强，但表达方式又很亲切。作为一名医学生，我认可这里的医学信息的准确性。已经推荐给了身边的朋友。',
  },
];

export const aboutContent = {
  brandStory: `性欲社诞生于一个简单的信念：每个人都有权利获取科学、专业的性健康知识，每个人都值得拥有健康、愉悦的亲密关系。

在中国，性教育长期处于缺位状态。学校的生理卫生课总是被一笔带过，家庭中更是鲜少有人敢于坦诚地谈论性。结果是，大量成年人带着困惑、误解甚至羞耻感，在亲密关系中摸索前行。

我们决定做点什么。2024年，一群来自医学、心理学和性教育领域的专业人士走到了一起，创建了性欲社——一个专注于两性健康知识与亲密关系指南的权威平台。

我们相信，知识可以消除恐惧，理解可以弥合隔阂，科学可以打破偏见。在这里，没有禁忌的话题，没有羞于启齿的问题，只有专业、温暖、负责任的答案。`,
  mission: '用科学与温度，点亮每个人的性福之路。',
  values: [
    {
      title: '科学严谨',
      description: '所有内容由具有专业资质的医生、心理咨询师和性教育专家撰写或审核，确保信息的准确性。',
      icon: 'ri-microscope-line',
    },
    {
      title: '温暖包容',
      description: '无论你是何种性取向、处于何种关系状态，在这里都能找到被理解和被尊重的感受。',
      icon: 'ri-heart-line',
    },
    {
      title: '无禁忌',
      description: '我们认为没有"不该问"的问题，只有需要被认真回答的困惑。打破沉默，从坦诚对话开始。',
      icon: 'ri-speak-line',
    },
    {
      title: '隐私至上',
      description: '浏览即匿名，数据不追踪。我们守护每一位读者的隐私安全。',
      icon: 'ri-shield-check-line',
    },
  ],
  team: [
    {
      name: '李医生',
      title: '联合创始人 / 医学总监',
      description: '三甲医院妇产科主治医师，15年临床经验，致力于女性健康科普教育。',
    },
    {
      name: '王心理咨询师',
      title: '联合创始人 / 心理学顾问',
      description: '国家二级心理咨询师，专注伴侣关系治疗与性心理咨询领域10年以上。',
    },
    {
      name: '张心理师',
      title: '资深作者 / 性心理治疗师',
      description: '性心理治疗师，在身体意象、性自尊等议题上有深入研究和丰富的临床经验。',
    },
  ],
  stats: [
    { number: '100+', label: '原创科普文章' },
    { number: '50万+', label: '累计阅读量' },
    { number: '10+', label: '专业作者团队' },
    { number: '98%', label: '读者好评率' },
  ],
};